import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import * as cloneDeep from 'lodash/cloneDeep';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import {
  ConnectionDetailModel,
  SiteModel,
  SiteStepperModel,
  Slab
} from 'src/app/models/index';
import {
  CommonService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import {
  ActionModeEnum,
  AlertService,
  Constants,
  Moment$,
  SiteStepperEnum
} from 'src/app/shared';

export const dateRangeValidator: ValidatorFn = (): ValidationErrors | null => {
  return { dateRangeInvalid: true };
};

@Component({
  selector: 'app-connection-details',
  templateUrl: './connection-details.component.html',
  styleUrls: ['./connection-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConnectionDetailsComponent
  implements OnInit, AfterViewChecked, AfterViewInit
{
  formData: UntypedFormGroup;
  stepTitle = 'Connection Details';
  siteId = '';
  model: ConnectionDetailModel;
  siteModel: SiteModel;
  actionMode: ActionModeEnum = ActionModeEnum.Viewing;
  year = 0;
  defaultSlabs: Slab[];
  emptySlab: Slab;
  maxNumberOfSlabs = 6;
  formControlIndex = [];
  indexCount = 0;
  requiredValidators = [Validators.required];
  enableSaveButton = false;
  moment = extendMoment(Moment);
  isOverlapSlabTime = false;

  constructor(
    private siteStepperService: SiteStepperService,
    private fb: UntypedFormBuilder,
    private cdRef: ChangeDetectorRef,
    private siteService: SiteService,
    private alertService: AlertService,
    private commonService: CommonService
  ) {
    this.formData = this.fb.group({
      contractedDemandCtr: ['', [Validators.required]],
      connectLoadCtr: ['', [Validators.required]],
      peakRecordedDemandCtr: ['', [Validators.required]],
      threeMnthsAvgDemandCtr: ['', [Validators.pattern('[0-9]*')]],
      discomZoneCtr: ['', [this.startWhitespace]],
      co2FactorCtr: [],
      lineTypeCtr: [],
      touCtr: ['', [Validators.required]],
      kvaTariffCtr: ['']
      // startTimeValueCtr_0: [''],
      // startTimeValueCtr_1: [''],
      // startTimeValueCtr_2: [''],
      // startTimeValueCtr_3: [''],
      // startTimeValueCtr_4: [''],
      // startTimeValueCtr_5: [''],
      // endTimeValueCtr_0: [''],
      // endTimeValueCtr_1: [''],
      // endTimeValueCtr_2: [''],
      // endTimeValueCtr_3: [''],
      // endTimeValueCtr_4: [''],
      // endTimeValueCtr_5: [''],
      // rateValueCtr_0: [''],
      // rateValueCtr_1: [''],
      // rateValueCtr_2: [''],
      // rateValueCtr_3: [''],
      // rateValueCtr_4: [''],
      // rateValueCtr_5: [''],
    });
  }
  public startWhitespace(control: UntypedFormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }
  private loadFormData() {
    this.siteService
      .getConnectionDetails(this.siteId)
      .subscribe((connDetail) => {
        this.formControlIndex = [];
        if (connDetail !== null && connDetail !== '') {
          if (connDetail.slabs !== null) {
            for (let i = 0; i < connDetail.slabs.length; i++) {
              const slab = connDetail.slabs[i];
              slab.startTime = Moment(slab.startTime)
                .utc()
                .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT);
              slab.endTime = Moment(slab.endTime)
                .utc()
                .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT);
              this.initFormControl(i);
            }
            this.indexCount = connDetail.slabs.length;
          }
          this.model = connDetail;
          this.isOverlapSlabTime = this.isOverlapTime();
        } else {
          this.model.siteId = this.siteId;
        }
      });
  }

  ngOnInit() {
    this.year = new Date().getFullYear();
    this.emptySlab = new Slab(
      Moment$(new Date(this.year, 1, 1, 6, 0, 0)).format(
        Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT
      ),
      Moment$(new Date(this.year, 1, 1, 9, 0, 0)).format(
        Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT
      ),
      null
    );
    this.defaultSlabs = [this.emptySlab];
    this.siteModel = new SiteModel();

    this.model = new ConnectionDetailModel();
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.ConnectionDetails &&
        !this.commonService.isNullOrUndefined(data.siteModel)
      ) {
        this.actionMode = ActionModeEnum.Viewing;
        this.siteModel = data.siteModel;
        this.siteId = this.siteModel.siteId;
        this.loadFormData();
      }
    });
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  public goPrevious = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.SiteCreation, this.siteModel)
    );
  };
  public goTo = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.ShiftDetails, this.siteModel)
    );
  };

  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    // if (!ObjectUtils.isNullOrUndefined(this.formData.get(fieldName))) {
    return this.formData.get(fieldName).hasError(errorCode);
  };
  //   return false;
  // }
  public submit = () => {
    const newModel = cloneDeep(this.model);
    if (newModel.tou === 'no') {
      console.log(newModel.tou);
    } else if (newModel.tou === 'yes') {
      for (let i = 0; i < newModel.slabs.length; i++) {
        const slab = newModel.slabs[i];
        const year = new Date().getFullYear();
        const month = new Date().getMonth();
        const date = new Date().getDate();
        const splitHourStartTime = slab.startTime.split(':');
        const splitHourEndTime = slab.endTime.split(':');
        slab.startTime = Moment$(
          new Date(
            year,
            month,
            date,
            splitHourStartTime[0],
            splitHourStartTime[1],
            0
          )
        ).format(Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_ZONE);
        slab.endTime = Moment$(
          new Date(
            year,
            month,
            date,
            splitHourEndTime[0],
            splitHourEndTime[1],
            0
          )
        ).format(Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_ZONE);
      }
    }
    this.siteService.saveConnDetails(newModel).subscribe((response) => {
      if (
        !this.commonService.isNullOrUndefined(response) &&
        !this.commonService.isNullOrUndefined(response.siteId)
      ) {
        this.alertService.message = 'Saved Successfully';
        this.alertService.showSuccess(this.alertService.message);
        this.enableSaveButton = true;
      } else {
        this.alertService.message = 'Failure in saving the data!';
        this.alertService.showError(this.alertService.message);
      }
    });
  };

  public changeToU = () => {
    switch (this.model.tou) {
      case 'no': {
        const requiredValidators = [Validators.required];
        this.formData.get('kvaTariffCtr').setValidators(requiredValidators);
        // Clean data validation of available slabs
        if (this.model.slabs !== undefined && this.model.slabs !== null) {
          this.model.slabs.forEach((_v, i) => {
            this.removeFormControl(this.formControlIndex[i]);
            this.formControlIndex.splice(i, 1);
          });
          // Delete all slabs
          this.model.slabs = undefined;
        }
        break;
      }
      case 'yes': {
        // Init default slabs
        if (this.model.slabs === undefined || this.model.slabs === null) {
          this.model.slabs = cloneDeep(this.defaultSlabs);
        }
        this.formControlIndex = [];
        // Clean validators
        this.formData.get('kvaTariffCtr').setValidators(null);
        // Add validators for slabs
        this.model.slabs.forEach((_v, i) => {
          this.initFormControl(i);
        });
        break;
      }
      default: {
        break;
      }
    }
    this.isOverlapSlabTime = this.isOverlapTime();
    this.formData.get('kvaTariffCtr').updateValueAndValidity();
  };

  public onStartTimeChanged = (event: any, index: number) => {
    event.preventDefault();
    const val = event.target.value;
    const splitHour = val.split(':');
    const slab = this.model.slabs[index];
    if (!this.commonService.isNullOrUndefined(slab)) {
      const tempDate = new Date(new Date().getFullYear());
      const tempDateEnd = new Date(new Date().getFullYear());
      // Set hours
      if (splitHour[0] != null) {
        tempDate.setHours(splitHour[0]);
      }
      // Then set minutes
      if (splitHour[1] != null) {
        tempDate.setMinutes(splitHour[1]);
      }
      // Then set seconds
      if (splitHour[2] != null) {
        tempDate.setSeconds(splitHour[2]);
      }
      const splitHourEndTime = slab.endTime.split(':');
      // Set hours
      if (splitHourEndTime[0] != null) {
        tempDateEnd.setHours(splitHourEndTime[0]);
      }
      // Then set minutes
      if (splitHourEndTime[1] != null) {
        tempDateEnd.setMinutes(splitHourEndTime[1]);
      }
      // Then set seconds
      if (splitHourEndTime[2] != null) {
        tempDateEnd.setSeconds(splitHourEndTime[2]);
      }
      const startTimeAbCtr = this.formData.get(
        `startTimeValueCtr_${this.formControlIndex[index]}`
      );
      const endTimeAbCtr = this.formData.get(
        `endTimeValueCtr_${this.formControlIndex[index]}`
      );
      if (tempDate >= tempDateEnd) {
        startTimeAbCtr.setValidators(dateRangeValidator);
      } else {
        startTimeAbCtr.setValidators(null);
        startTimeAbCtr.setValidators(this.requiredValidators);
        endTimeAbCtr.setValidators(null);
        endTimeAbCtr.setValidators(this.requiredValidators);
        const error = endTimeAbCtr.getError('dateRangeInvalid');
        if (error) {
          endTimeAbCtr.setErrors(null);
        }
      }
      startTimeAbCtr.updateValueAndValidity();
      endTimeAbCtr.updateValueAndValidity();

      this.isOverlapSlabTime = this.isOverlapTime();
    }
  };

  public onEndTimeChanged = (event: any, index: number) => {
    event.preventDefault();
    const val = event.target.value;
    const splitHour = val.split(':');
    const slab = this.model.slabs[index];
    if (!this.commonService.isNullOrUndefined(slab)) {
      const tempDate = new Date(new Date().getFullYear());
      const tempDateStart = new Date(new Date().getFullYear());
      // Set hours
      if (splitHour[0] != null) {
        tempDate.setHours(splitHour[0]);
      }
      // Then set minutes
      if (splitHour[1] != null) {
        tempDate.setMinutes(splitHour[1]);
      }
      // Then set seconds
      if (splitHour[2] != null) {
        tempDate.setSeconds(splitHour[2]);
      }
      const splitHourStartTime = slab.startTime.split(':');
      // Set hours
      if (splitHourStartTime[0] != null) {
        tempDateStart.setHours(splitHourStartTime[0]);
      }
      // Then set minutes
      if (splitHourStartTime[1] != null) {
        tempDateStart.setMinutes(splitHourStartTime[1]);
      }
      // Then set seconds
      if (splitHourStartTime[2] != null) {
        tempDateStart.setSeconds(splitHourStartTime[2]);
      }
      const startTimeAbCtr = this.formData.get(
        `startTimeValueCtr_${this.formControlIndex[index]}`
      );
      const endTimeAbCtr = this.formData.get(
        `endTimeValueCtr_${this.formControlIndex[index]}`
      );
      if (tempDate < tempDateStart) {
        endTimeAbCtr.setValidators(dateRangeValidator);
      } else {
        endTimeAbCtr.setValidators(null);
        endTimeAbCtr.setValidators(this.requiredValidators);
        const error = startTimeAbCtr.getError('dateRangeInvalid');
        if (error) {
          startTimeAbCtr.setErrors(null);
        }
        startTimeAbCtr.setValidators(null);
        startTimeAbCtr.setValidators(this.requiredValidators);
      }
      endTimeAbCtr.updateValueAndValidity();
      startTimeAbCtr.updateValueAndValidity();

      this.isOverlapSlabTime = this.isOverlapTime();
    }
  };

  public validateTimeSlots = () => {
    let isValid = true;
    if (this.model !== undefined && this.model.slabs !== undefined) {
      for (let i = 0; i < this.model.slabs.length; i++) {
        if (
          this.model.slabs[i].endTime === undefined ||
          this.model.slabs[i].startTime >= this.model.slabs[i].endTime
        ) {
          isValid = false;
          break;
        }
      }
    }
    return isValid;
  };

  clear(index) {
    const newSlab = cloneDeep(this.emptySlab);
    this.model.slabs[this.formControlIndex[index]] = newSlab;
    this.isOverlapSlabTime = this.isOverlapTime();
  }

  remove(event, index) {
    event.preventDefault();
    // Clear controls
    const formIndex = this.formControlIndex[index];
    this.removeFormControl(formIndex);

    this.formControlIndex.splice(index, 1);
    this.model.slabs.splice(index, 1);
    this.isOverlapSlabTime = this.isOverlapTime();
  }

  add() {
    this.indexCount = this.indexCount + 1;
    const newSlab = cloneDeep(this.emptySlab);
    this.model.slabs.push(newSlab);
    this.isOverlapSlabTime = this.isOverlapTime();

    this.initFormControl(this.indexCount);
  }

  private removeFormControl(index) {
    const startTimeControlName = 'startTimeValueCtr_' + index;
    const startTimeAbCtr = this.formData.get(startTimeControlName);
    if (!this.commonService.isNullOrUndefined(startTimeAbCtr)) {
      startTimeAbCtr.setValidators(null);
      startTimeAbCtr.updateValueAndValidity();
      this.formData.removeControl(startTimeControlName);
    }

    const endTimeControlName = 'endTimeValueCtr_' + index;
    const endTimeAbCtr = this.formData.get(endTimeControlName);
    if (!this.commonService.isNullOrUndefined(endTimeAbCtr)) {
      endTimeAbCtr.setValidators(null);
      endTimeAbCtr.updateValueAndValidity();
      this.formData.removeControl(endTimeControlName);
    }

    const rateControlName = 'rateValueCtr_' + index;
    const rateValueAbCtr = this.formData.get(rateControlName);
    if (!this.commonService.isNullOrUndefined(rateValueAbCtr)) {
      rateValueAbCtr.setValidators(null);
      rateValueAbCtr.updateValueAndValidity();
      this.formData.removeControl(rateControlName);
    }
  }

  private initFormControl(index) {
    this.formControlIndex.push(index);

    const startTimeControlName = `startTimeValueCtr_${index}`;
    let startTimeAbCtr = this.formData.get(startTimeControlName);
    if (this.commonService.isNullOrUndefined(startTimeAbCtr)) {
      this.formData.addControl(
        startTimeControlName,
        new UntypedFormControl('', Validators.required)
      );
      startTimeAbCtr = this.formData.get(startTimeControlName);
    }
    startTimeAbCtr.updateValueAndValidity();

    const endTimeControlName = `endTimeValueCtr_${index}`;
    let endTimeAbCtr = this.formData.get(endTimeControlName);
    if (this.commonService.isNullOrUndefined(endTimeAbCtr)) {
      this.formData.addControl(
        endTimeControlName,
        new UntypedFormControl('', Validators.required)
      );
      endTimeAbCtr = this.formData.get(endTimeControlName);
    }
    endTimeAbCtr.updateValueAndValidity();

    const rateValueControlName = `rateValueCtr_${index}`;
    let rateValueAbCtr = this.formData.get(rateValueControlName);
    if (this.commonService.isNullOrUndefined(rateValueAbCtr)) {
      this.formData.addControl(
        rateValueControlName,
        new UntypedFormControl('', Validators.required)
      );
      rateValueAbCtr = this.formData.get(`rateValueCtr_${index}`);
    }
    rateValueAbCtr.updateValueAndValidity();
  }

  addDay(dateString, addToDays) {
    const date = new Date(dateString);
    date.setDate(date.getDate() + addToDays);
    return date;
  }

  isOverlapTime() {
    const result = false;
    const timeRanges = Object.assign([], this.model.slabs);

    if (timeRanges.length < 2) {
      return false;
    }

    for (let i = 0; i < timeRanges.length - 1; i++) {
      for (let j = i + 1; j < timeRanges.length; j++) {
        const year = new Date().getFullYear();
        const month = new Date().getMonth();
        const date = new Date().getDate();
        let isAdded1 = false;
        let isAdded2 = false;

        const splitHourStartTime1 = timeRanges[i].startTime.split(':');
        const splitHourEndTime1 = timeRanges[i].endTime.split(':');
        let start1 = new Date(
          year,
          month,
          date,
          splitHourStartTime1[0],
          splitHourStartTime1[1],
          0
        );
        let end1 = new Date(
          year,
          month,
          date,
          splitHourEndTime1[0],
          splitHourEndTime1[1],
          0
        );
        if (start1 > end1) {
          end1 = this.addDay(end1, 1);
          isAdded1 = true;
        }

        const splitHourStartTime2 = timeRanges[j].startTime.split(':');
        const splitHourEndTime2 = timeRanges[j].endTime.split(':');
        let start2 = new Date(
          year,
          month,
          date,
          splitHourStartTime2[0],
          splitHourStartTime2[1],
          0
        );
        let end2 = new Date(
          year,
          month,
          date,
          splitHourEndTime2[0],
          splitHourEndTime2[1],
          0
        );
        if (start2 > end2) {
          end2 = this.addDay(end2, 1);
          isAdded2 = true;
        }

        if (isAdded1 && !isAdded2) {
          start2 = this.addDay(start2, 1);
          end2 = this.addDay(end2, 1);
        }
        if (!isAdded1 && isAdded2) {
          start1 = this.addDay(start1, 1);
          end1 = this.addDay(end1, 1);
        }

        const range1 = this.moment.range(start1, end1);
        const range2 = this.moment.range(start2, end2);
        if (range1.overlaps(range2, { adjacent: true })) {
          return true;
        }
      }
    }

    return result;
  }
}
